import { createApi } from "@reduxjs/toolkit/query/react";
import { SerializedError } from "@reduxjs/toolkit";
import axios, { AxiosRequestConfig } from "axios";
import { deleteToken } from "./reducers/user";

export type AxiosResponseError = {
  error: { status: any; data: any } | SerializedError;
};

export const backendURL =
  window?.env.REACT_APP_BACKEND_URL || "http://localhost:3003/";
const requestTimeout = window?.env.REACT_APP_REQUEST_TIMEOUT_TIME
  ? Number(window?.env.REACT_APP_REQUEST_TIMEOUT_TIME)
  : 5000;
const axiosBaseQuery =
  (axiosOptions: AxiosRequestConfig) =>
  async (requestOptions: AxiosRequestConfig) => {
    const token = localStorage.getItem("token");
    const isFormData = requestOptions.data instanceof FormData;
    try {
      const result = await axios({
        ...axiosOptions,
        ...requestOptions,
        baseURL: backendURL, // set the baseURL
        timeout: requestTimeout, // set the timeout to 5000ms (5 seconds)
        headers: {
          ...requestOptions.headers,
          "Content-Type": isFormData ? undefined : "application/json",
          Authorization: token ? token : undefined,
        },
      });
      return { data: result.data };
    } catch (axiosError: any) {
      let err = axiosError;
      const status = err.response?.status;
      if (status === 401 || status === 403) {
        deleteToken();
      }
      return {
        error: { status, data: err.response?.data },
      };
    }
  };

export const tagTypes = ["Users", "Homes"] as const;
export const backendApi = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery({
    baseURL: backendURL,
  }),
  tagTypes,
  endpoints: () => ({}),
});
